import styled from 'styled-components'
import { theme } from '@/client/components'
const { color } = theme

export const ScubscriptionPanel = styled.div`
  display: flex;
  flex-wrap: wrap;
  background: ${color.grayscale.babyBlue};
  padding: 2rem 0;
  justify-content: center;
`
export const ButtonLinks = styled.div`
  display: flex;
`
